type Platform = General.Platform;
type PlatformUpperCase = General.PlatformUpperCase;

export const platformList: Platform[] = [
  'shopee',
  'lazada',
  'tokopedia',
  'tiktok',
  'tiktok_us',
  'aliexpress',
  'mercado',
  'kwai',
  'facebook',
];

export const isValidPlatform = (
  platform: string,
  list: Platform[] = platformList,
): platform is Platform => {
  return list.includes(platform as Platform);
};

export const platformUpperCaseMap: Record<Platform, PlatformUpperCase> = {
  shopee: 'SHOPEE',
  lazada: 'LAZADA',
  tokopedia: 'TOKOPEDIA',
  tiktok: 'TIKTOK',
  aliexpress: 'ALIEXPRESS',
  tiktok_us: 'TIKTOK_US',
  mercado: 'MERCADO',
  kwai: 'KWAI',
  facebook: 'FACEBOOK',
};

export const upperCasePlatformMap: Record<PlatformUpperCase, Platform> = {
  SHOPEE: 'shopee',
  LAZADA: 'lazada',
  TOKOPEDIA: 'tokopedia',
  TIKTOK: 'tiktok',
  ALIEXPRESS: 'aliexpress',
  TIKTOK_US: 'tiktok_us',
  MERCADO: 'mercado',
  KWAI: 'kwai',
  FACEBOOK: 'facebook',
};

export const platformLabelMap: Record<General.PlatformTunnel, string> = {
  shopee: 'Shopee',
  lazada: 'Lazada',
  wa_biz: 'WhatsApp',
  tokopedia: 'Tokopedia',
  tiktok: 'TikTok',
  aliexpress: 'AliExpress',
  tiktok_us: 'TikTok US',
  mercado: 'Mercado',
  kwai: 'Kwai',
  facebook: 'Facebook',
};

export const platformUploadSizeLimitMap: Record<General.PlatformTunnel, number> = {
  shopee: 10 * 1024 * 1024,
  lazada: 3 * 1024 * 1024,
  wa_biz: 16 * 1024 * 1024,
  tokopedia: 16 * 1024 * 1024,
  tiktok: 15 * 1024 * 1024,
  aliexpress: 3 * 1024 * 1024,
  tiktok_us: 15 * 1024 * 1024,
  mercado: 5 * 1024 * 1024,
  kwai: 10 * 1024 * 1024,
  facebook: 8 * 1024 * 1024,
};

const defaultUploadImageAccept = ['jpg', 'jpeg', 'png', 'gif'];

export const platformUploadImageAcceptMap: Record<General.PlatformTunnel, string[]> = {
  shopee: defaultUploadImageAccept,
  lazada: ['jpg', 'png'],
  wa_biz: defaultUploadImageAccept,
  tokopedia: defaultUploadImageAccept,
  tiktok: defaultUploadImageAccept,
  aliexpress: ['jpg', 'jpeg', 'gif'],
  tiktok_us: defaultUploadImageAccept,
  mercado: ['jpg', 'png', 'pdf'],
  kwai: defaultUploadImageAccept,
  facebook: defaultUploadImageAccept,
};

export const platformExecuteContentLimitLengthMap = {
  SHOPEE: 2000,
  LAZADA: 2000,
  TOKOPEDIA: 2000,
  TIKTOK: 2000,
  TIKTOK_US: 2000,
  ALIEXPRESS: 2000,
  MERCADO: 350,
  KWAI: 2000,
  FACEBOOK: 2000,
};

export const supportSendVideoPlatforms: Conversation.Conversation['channel'][] = [
  'SHOPEE',
  'LAZADA',
  'WA_BIZ',
  'MERCADO',
  'KWAI',
  'FACEBOOK',
  'TIKTOK',
  'TIKTOK_US',
];

export const supportSendImagePlatforms: Conversation.Conversation['channel'][] = [
  'SHOPEE',
  'LAZADA',
  'TIKTOK',
  'TIKTOK_US',
  'WA_BIZ',
  'ALIEXPRESS',
  'KWAI',
  'FACEBOOK',
];

export const supportSendStickerPlatforms: Conversation.Conversation['channel'][] = [
  'SHOPEE',
  'LAZADA',
  'TIKTOK',
  'TIKTOK_US',
  'ALIEXPRESS',
  'TOKOPEDIA',
  'KWAI',
];
